export const instalarSublimeText = [
  {
    title: "Guía completa para descargar e instalar Sublime Text en tu computadora",
    value: `
Sigue estos pasos detallados para instalar Sublime Text, un editor de código ligero, rápido y versátil ideal para programadores y estudiantes.

---

1. **Ir al sitio web de Sublime Text**  
   Abre tu navegador y accede al sitio oficial de Sublime Text en: [https://www.sublimetext.com](https://www.sublimetext.com)  
   Desde la página principal, podrás ver las últimas versiones disponibles y recomendaciones para cada sistema operativo.  
   Este es el sitio seguro y confiable para descargar el programa.  
   ![Sitio oficial de Sublime Text](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-1.png)

2. **Seleccionar tu sistema operativo**  
   En la sección de descargas, elige el sistema operativo que utilizas en tu computadora: Windows, Mac o Linux.  
   Haz clic sobre el botón correspondiente para iniciar la descarga del instalador adecuado.  
   En este ejemplo, seleccionamos la versión para **Windows**.  
   ![Elegir sistema operativo](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-2.png)

3. **Ejecutar el instalador**  
   Una vez que la descarga haya finalizado, busca el archivo descargado en tu carpeta de descargas y haz doble clic para ejecutarlo.  
   Aparecerá la ventana del instalador de Sublime Text preguntando en qué carpeta deseas realizar la instalación.  
   Puedes dejar la ruta por defecto o elegir otra si lo prefieres.  
   ![Ejecutar instalador](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-3.PNG)

4. **Opciones adicionales de instalación**  
   Durante la instalación, tendrás la opción de marcar casillas adicionales.  
   Es recomendable activar la opción **"Add to explorer context menu"** (Agregar al menú contextual del explorador).  
   Esto permitirá que puedas abrir archivos o carpetas directamente en Sublime Text desde el menú del botón derecho en el explorador de Windows, facilitando tu flujo de trabajo.  
   ![Opciones de instalación](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-4.PNG)

5. **Confirmar instalación**  
   Revisa que las opciones sean correctas y haz clic en el botón **"Install"** para iniciar el proceso de instalación.  
   El instalador copiará los archivos necesarios y preparará Sublime Text para que esté listo en tu sistema.  
   ![Confirmar instalación](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-5.PNG)

6. **Finalizar instalación**  
   Cuando veas la pantalla de finalización, simplemente haz clic en **"Finish"**.  
   Esto cerrará el asistente y Sublime Text ya habrá quedado instalado correctamente en tu computadora.  
   ![Finalizar instalación](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-6.PNG)

7. **Abrir Sublime Text por primera vez**  
   Ahora puedes buscar **Sublime Text** en el menú de inicio de tu computadora y abrirlo.  
   Al iniciarse, verás una ventana en blanco lista para comenzar a programar, escribir texto o abrir tus archivos y proyectos.  
   ¡Ya tienes tu editor de código listo para usar!  
   ![Abrir Sublime Text](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/11-7.png)

---

**Consejo adicional:**  
Sublime Text es muy liviano y permite instalar plugins para trabajar con distintos lenguajes de programación y mejorar tu productividad.  
Puedes personalizar su apariencia, instalar temas y gestionar proyectos fácilmente desde la interfaz.

¡Disfruta tu experiencia programando con Sublime Text!
`
  }
];

export default instalarSublimeText;
